import React, { useMemo } from 'react';
import { Box, Typography } from '@mui/material';
import { spotGuidePath } from 'utils/urls';
import { TravelDetails } from 'types/travelDetails';
import WavetrakLink from '../WavetrakLink';

import styles from './SpotTravelInfoSummary.module.scss';

interface Props {
  spotId: string;
  spotName: string;
  travelDetails: TravelDetails;
}

const SpotTravelInfoSummary: React.FC<Props> = ({ spotId, spotName, travelDetails }) => {
  const getTruncatedDescription = (description: string) => {
    const returnObject = {
      description,
      truncated: false,
    };
    if (description.length > 500) {
      returnObject.description = description.slice(0, 500);
      returnObject.truncated = true;
    }
    return returnObject;
  };
  const { description, truncated } = getTruncatedDescription(travelDetails?.description || '');
  const descriptionMarkup = useMemo(
    () => (description && truncated ? `${description.trim()}...` : description.trim()),
    [description, truncated],
  );
  return (
    <Box>
      <Typography variant="title2" className={styles.header}>
        {spotName} Surf Guide
      </Typography>
      {travelDetails?.description && (
        <Box className={styles.description}>
          <Typography component="p">
            {travelDetails?.description && (
              <Typography
                component="span"
                dangerouslySetInnerHTML={{ __html: `${descriptionMarkup}&nbsp;` }}
              />
            )}
            <WavetrakLink href={spotGuidePath({ spotName, spotId })}>Read more</WavetrakLink>
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default SpotTravelInfoSummary;
